"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIconPosition = exports.defaultSize = exports.defaultVariant = exports.iconPositions = exports.buttonSizes = exports.buttonVariants = void 0;
exports.buttonVariants = ['primary', 'secondary', 'solid', 'ghost', 'text'];
exports.buttonSizes = ['mini', 'xsmall', 'small', 'medium', 'large', 'xlarge'];
exports.iconPositions = ['left', 'right'];
exports.defaultVariant = 'primary';
exports.defaultSize = 'medium';
exports.defaultIconPosition = 'left';
